import { TextField, InputLabel, Stack } from '@mui/material';
import React from 'react';

interface SettingNumberFieldProps {
  value: number | string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  required?: boolean;
}

const SettingNumberField: React.FC<SettingNumberFieldProps> = ({
  value,
  onChange,
  label = 'Number',
  required = false,
}) => (
  <Stack
    direction={{ xs: 'column', sm: 'row' }}
    spacing={3}
    alignItems={{ xs: 'stretch', sm: 'center' }}>
    <InputLabel
      sx={{
        minWidth: { xs: 0, sm: 130 },
        color: 'text.primary',
        fontWeight: 500,
        mb: { xs: 1, sm: 0 },
      }}>
      {label}
    </InputLabel>
    <TextField
      type="number"
      required={required}
      value={value}
      onChange={onChange}
      size="small"
      sx={{ flex: 1 }}
      fullWidth
    />
  </Stack>
);

export default SettingNumberField;
